import { ChatAction, messageHasActions } from "~vue/chatActions";
import type { ChatMessage } from "~vue/types/chat";
import { ref } from "vue";

export const nadiaIntelligenceActions: ChatAction[] = [ChatAction.TAGGED_PERSON, ChatAction.INTERNAL_THINKING, ChatAction.VALUES_INSIGHT, ChatAction.WORKIQ_COLLABORATION_SOURCES];
const isNadiaIntelligenceOpenMap = ref<Record<number, boolean>>({});

export const useNadiaIntelligence = () => {
    const isNadiaIntelligenceOpen = (messageId: number) => isNadiaIntelligenceOpenMap.value[messageId] || false;
    const setIsNadiaIntelligenceOpen = (messageId: number, isOpen: boolean) => {
        isNadiaIntelligenceOpenMap.value[messageId] = isOpen;
    };
    const shouldShowNadiaIntelligence = (message: ChatMessage) => {
        return messageHasActions(message, nadiaIntelligenceActions);
    };

    return { isNadiaIntelligenceOpen, setIsNadiaIntelligenceOpen, shouldShowNadiaIntelligence };
};
